import comp from "./LevelEditorTable";
export default comp;
